import _Array$from from "../../core-js/array/from";
import _isIterable from "../../core-js/is-iterable";
import _Symbol from "../../core-js/symbol";
export default function _iterableToArray(iter) {
  if (typeof _Symbol !== "undefined" && _isIterable(Object(iter))) return _Array$from(iter);
}


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/@babel/runtime-corejs3/helpers/esm/iterableToArray.js
// module id = 2687
// module chunks = 1